import {Map, List, fromJS} from 'immutable';
import {ReduceStore} from 'flux/utils';
import Dispatcher from '../../dispatcher';

import {
    COMMENTS_ADD,
    COMMENTS_ADDING,
    COMMENTS_LOADING,
    COMMENTS_LOADED,
    COMMENTS_REPLY_ACTIVE
} from '../../constants';

class CounterStore extends ReduceStore {
    getInitialState() {
        return Map({
            loading: true,
            addingComment: false,
            comments: List(),
            users: List(),
            activeReply: 0
        });
    }

    get loading() {
        return this.getState().get('loading');
    }

    get users() {
        return this.getState().get('users');
    }

    get comments() {
        return this.getState().get('comments');
    }

    get addingComment() {
        return this.getState().get('addingComment');
    }

    get activeReply() {
        return this.getState().get('activeReply');
    }

    reduce(state, action) {
        switch (action.type) {
            case COMMENTS_ADD:
                return state;

            case COMMENTS_LOADING:
                return state.merge({
                    loading: true
                });

            case COMMENTS_ADDING:
                return state.merge({
                    addingComment: true
                });

            case COMMENTS_REPLY_ACTIVE:
                return state.merge({
                    activeReply: action.id
                });

            case COMMENTS_LOADED:
                return state.merge({
                    comments: fromJS(action.data.comments),
                    users: fromJS(action.data.users),
                    loading: false,
                    addingComment: false
                });
            default:
                return state;
        }
    }
}

export default new CounterStore(Dispatcher);